import {ServiceClass} from '@/decorators';
import {Count} from '@/globals';
import {BaseApi} from './base.api';

@ServiceClass()
export class DashboardApi extends BaseApi {
    public getSiteStatistics(siteId: string) {
        return this.GET_RequestAsync<Count>(`${this.ApiUrl}/dashboard/sites/${siteId}/statistics`);
    }

    public getAreasCountBySiteId(siteId: string) {
        return this.GET_RequestAsync<Count>(`${this.ApiUrl}/dashboard/sites/${siteId}/areas-count`);
    }

    public getSubAreasCountBySiteId(siteId: string) {
        return this.GET_RequestAsync<Count>(`${this.ApiUrl}/dashboard/sites/${siteId}/sub-areas-count`);
    }

    public getEquipmentCountBySiteId(siteId: string) {
        return this.GET_RequestAsync<Count>(`${this.ApiUrl}/dashboard/sites/${siteId}/equipment-count`);
    }

    public getWarningsCountBySiteId(siteId: string) {
        return this.GET_RequestAsync<Count>(`${this.ApiUrl}/dashboard/sites/${siteId}/warnings-count`);
    }

    public getCompletedCorrectiveActionsCount(siteId: string) {
        return this.GET_RequestAsync<Count>(`${this.ApiUrl}/dashboard/sites/${siteId}/corrective-actions-count/completed`);
    }

    public getOnGoingCorrectiveActionsCount(siteId: string) {
        return this.GET_RequestAsync<Count>(`${this.ApiUrl}/dashboard/sites/${siteId}/corrective-actions-count/on-going`);
    }

    public getCompletedInspectionsCount(siteId: string) {
        return this.GET_RequestAsync<Count>(`${this.ApiUrl}/dashboard/sites/${siteId}/inspections-count/completed`);
    }

    public getOnGoingInspectionsCount(siteId: string) {
        return this.GET_RequestAsync<Count>(`${this.ApiUrl}/dashboard/sites/${siteId}/inspections-count/on-going`);
    }

    public getDelayedInspectionsCount(siteId: string) {
        return this.GET_RequestAsync<Count>(`${this.ApiUrl}/dashboard/sites/${siteId}/inspections-count/delayed`);
    }

    public getAsPlannedInspectionsCount(siteId: string) {
        return this.GET_RequestAsync<Count>(`${this.ApiUrl}/dashboard/sites/${siteId}/inspections-count/as-planned`);
    }

    public async getLocationCountOfEachTypeByTimeType(siteId: string, countBy: string) {
        return this.GET_RequestAsync<{Time: string; Month: string; Areas: number; Equipments: number}[]>(
            `${this.ApiUrl}/dashboard/sites/${siteId}/location-count/${countBy}`
        );
    }

    public async getZoneEquipmentCounts(siteId: string): Promise<{gasZoneCounts: any[]; dustZoneCounts: any[]}> {
        return this.GET_RequestAsync<{gasZoneCounts: any[]; dustZoneCounts: any[]}>(`${this.ApiUrl}/dashboard/sites/${siteId}/zone-equipment-counts`);
    }

    public async getInspectionQuestionsStatistics(siteId: string): Promise<{
        inspectionQuestionsCountAccordingToFailPassNA: {AnswerStatus: string[]; TotalQuestions: number[]};
        inspectionQuestionsCountAccordingToGrade: {Grade: string[]; TotalQuestions: number[]};
    }> {
        return this.GET_RequestAsync<{
            inspectionQuestionsCountAccordingToFailPassNA: {AnswerStatus: string[]; TotalQuestions: number[]};
            inspectionQuestionsCountAccordingToGrade: {Grade: string[]; TotalQuestions: number[]};
        }>(`${this.ApiUrl}/dashboard/sites/${siteId}/inspection-questions-statistics`);
    }
}
